import { useState, useEffect } from "react";
import SocketClient from "../../services/socket/SocketClient";


export default function useSocketClientStatus() {
    
    const [state, setState] = useState(SocketClient.IsDOCWindowsOnline);    

    SocketClient.OnDocWinSocketStatusChange.Add(setState);   

    return state;
}
